import { render, staticRenderFns } from "./BatteryLevel.vue?vue&type=template&id=2e726472&"
import script from "./BatteryLevel.vue?vue&type=script&lang=ts&"
export * from "./BatteryLevel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports